import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP, BACKEND_API_URL } from "@/utils/http-common"

export default {
  // Project structure
  projectTree($, projectId) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/ged/projects/${projectId}/folders`)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  // Manage Folders
  createFolder($, projectId, folder) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/ged/projects/${projectId}/folders`, folder)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },

  deleteFolder($, projectId, folderId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/ged/projects/${projectId}/folders/${folderId}`)
        .then(response => resolve(response.data))
        .catch(error => {
          return reject(error)
        })
    })
  },
  // Manage Documents / Files
  deleteDocument($, projectId, documentId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/ged/projects/${projectId}/files/${documentId}`)
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  renameDocument($, projectId, FileId, name) {
    return new Promise((resolve, reject) => {
      HTTP.put(`/ged/projects/${projectId}/files/${FileId}/rename`, { name })
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  changeExpireDate($, projectId, FileId, date) {
    return new Promise((resolve, reject) => {
      HTTP.patch(`/ged/projects/${projectId}/files/${FileId}/expire`, { date })
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  renameFolder($, projectId, folderId, name) {
    return new Promise((resolve, reject) => {
      HTTP.put(`/ged/projects/${projectId}/folders/${folderId}/rename`, { name })
        .then(response => resolve(response.data))
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  addDocument($, projectId, document) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/ged/projects/${projectId}/files`, document)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  //Reporting
  createReport($, projectId, report) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/ged/projects/${projectId}/reports`, report)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  deleteReport($, projectId, reportId) {
    return new Promise((resolve, reject) => {
      HTTP.delete(`/ged/projects/${projectId}/reports/${reportId}`)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          new EHC(DEFAULTS_HANDLERS).intercept(error)
          reject(error)
        })
    })
  },
  /** Download generated .pdf file
   * Note: Use XMLHttpRequest because axios get empty data when trying to fetch "blob" data
   */
  downloadFile($, projectId, fileType, lang, objectId) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/ged/projects/${projectId}/${fileType}/${lang}/${objectId}`

      // Prepare request
      let xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (xhr.status === 200) resolve(xhr.response)
        else reject(xhr)
      }

      // Execute request
      xhr.send()
    })
  },
  // analyzeImage($, datas) {
  //   return new Promise((resolve, reject) => {
  //     HTTP.post(`/ged/analyze-image`, datas, { responseType: "blob" })
  //       .then(response => {
  //         resolve(response)
  //       })
  //       .catch(error => {
  //         reject(error)
  //       })
  //   })
  // },
  analyzeImage($, projectId, datas) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/ged/projects/${projectId}/analyze-image`
      var xhr = new XMLHttpRequest()
      xhr.open("POST", url, true)
      xhr.responseType = "blob"
      xhr.setRequestHeader("Content-Type", "application/json")
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)

      xhr.onload = function () {
        if (xhr.status === 200) resolve(xhr.response)
        else reject(xhr)
      }

      xhr.onerror = function () {
        reject(xhr.statusText)
      }

      xhr.send(JSON.stringify(datas))
    })
  },
  /** Download generated .pdf file
   * Note: Use XMLHttpRequest because axios get empty data when trying to fetch "blob" data
   */
  wordExport($, projectId, fileType, objectId) {
    return new Promise((resolve, reject) => {
      const url = `${BACKEND_API_URL}/ged/projects/${projectId}/${fileType}/${objectId}/word`

      // Prepare request
      let xhr = new XMLHttpRequest()
      xhr.open("GET", url, true)
      xhr.setRequestHeader("authorization", "Token " + $.$store.state.app.user.key)
      xhr.setRequestHeader("X-Timezone-Name", $.$store.state.app.user.tzName)
      xhr.responseType = "blob"
      xhr.onload = function () {
        if (xhr.status === 200) resolve(xhr.response)
        else reject(xhr)
      }

      // Execute request
      xhr.send()
    })
  }
}
